// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","687":"complete-application","718":"enter-bvn","936":"device-details"}[chunkId] || chunkId) + "." + {"316":"205a41a4","594":"38d1a7e5","687":"51498827","718":"ba16cc1a","936":"5affcd0a"}[chunkId] + ".js";
};